<template>
	<div class="order">
		<div class="tabdiv">
			<el-tabs v-model="activeName">
			    <el-tab-pane :label="v.label" :name="v.name" v-for="(v,k) in tablist" :key="k">
					<div slot="label">
						<span>{{v.label}}</span>
						<span class="red" v-if="v.num>0">({{v.num}})</span>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onexport()">订单列表导出</el-button>
			<el-button type="primary" size="small" v-if="btnshow == 1" @click="onpeihuoAll()">批量配货</el-button>
			<el-button type="primary" size="small" v-if="btnshow == 2" @click="onsendAll()">批量发货</el-button>
			<el-button type="primary" size="small" v-if="btnshow == 2" @click="onidelivery()">批量快递导入</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0px"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.date_type" placeholder="时间类型">
							<el-option label="时间类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_date_type"
								:key="k">
							</el-option>
						</el-select>

						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>

					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.delivery_id" placeholder="实发快递" filterable size="small">
							<el-option label="实发快递" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="订单号"></el-input>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.cfrom" placeholder="订单来源">
							<el-option label="订单来源" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_cfrom" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" v-if="activeName == 'qb'">
						<el-select v-model="formfilter.order_status" placeholder="订单状态">
							<el-option label="订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_status"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.recv_name" placeholder="收货人"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.delivery_num" placeholder="快递号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.out_trade_no" placeholder="客户单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.recv_mobbile" placeholder="手机号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.style_number" placeholder="款号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.seller_mark" placeholder="标记">
							<el-option label="标记" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.mark" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.seller_memo" placeholder="备忘"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.apply_cancel" placeholder="申请取消状态">
							<el-option label="申请取消" value=""></el-option>
							<el-option label="未申请" :value="0"></el-option>
							<el-option label="已申请" :value="1"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv tablediv-compact" ref="tablediv">
				<el-table :data="list" style="width: 100%" border :cell-class-name="cellClassName" height="100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left"/>
					<el-table-column prop="order_status_str" align="center" header-align="center" label="状态"
						fixed="left">
					</el-table-column>
					<el-table-column label="订单编号" align="center" header-align="center" min-width="140px">
						<template slot-scope="scope">
							<div @click="oncopy(scope.row.trade_no)">{{scope.row.trade_no}}</div>
							<div v-if="scope.row.order_status == 3 && scope.row.apply_cancel == 1">
								<div class="red">申请取消{{ scope.row.is_auto_cancel == 1 ? '（系统）' : '' }}</div>
								<div class="red">代理要持续跟进。若已发出，联系渠道和快递追回或改地址</div>
							</div>
							<div v-else-if="scope.row.is_auto_cancel == 1" class="red" style="font-size: 12px;">（系统）</div>
						</template>
					</el-table-column>
					<el-table-column label="下单日期/预发日期/是否准时" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">
							<div class="datetime-stack">
								<div>{{ formatOrderDate(scope.row.create_time_str) }}</div>
								<div v-if="formatOrderTime(scope.row.create_time_str)" class="datetime-time">{{ formatOrderTime(scope.row.create_time_str) }}</div>
							</div>
							<div class="datetime-stack">
								<div>{{ formatOrderDate(scope.row.prev_time_str) }}</div>
								<div v-if="formatOrderTime(scope.row.prev_time_str)" class="datetime-time">{{ formatOrderTime(scope.row.prev_time_str) }}</div>
							</div>
							<div :style="ontimestr(scope.row.is_on_time_str)">{{scope.row.is_on_time_str}}</div>
						</template>
					</el-table-column>
					<el-table-column label="款号|尺码|数量|实发" align="center" header-align="center" min-width="200px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_detail" :key="k">
								{{v.product_style_number}}|{{v.product_size}}|{{v.num}}|{{v.true_num}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="recv_name" label="收货人" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="total_num" label="下单数量" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="total_true_num" label="实发数量" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="delivery_name" label="下单快递" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<!-- 配货中填写 非配货中展示 -->
					<el-table-column label="实发快递" align="center" header-align="center" min-width="174px"
						class-name="delivery-name-column">
						<template slot-scope="scope">
							<div v-if="inputshow(scope.row,1)">
								<div
									v-for="(v,k) in scope.row.order_delivery"
									:key="k"
									class="delivery-name-text"
								>{{v.delivery_name}}</div>
							</div>
							<div v-if="inputshow(scope.row,2,scope.$index)">
								<el-select v-model="scope.row.order_delivery[0].delivery_id" placeholder="快递" filterable
									size="small" style="width: 100%">
									<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery"
										:key="k">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="快递单号" align="center" header-align="center" min-width="160px"
						class-name="delivery-num-column">
						<template slot-scope="scope">
							<div v-if="inputshow(scope.row,1)">
								<div
									v-for="(v,k) in scope.row.order_delivery"
									:key="k"
									class="delivery-num-text"
									@click="oncopy(v.delivery_num)"
								>
									{{v.delivery_num}}
									<span class="k" v-if="v.cfrom==1">快</span>
									<span class="j" v-if="v.cfrom==2">聚</span>
								</div>
							</div>
							<div v-if="inputshow(scope.row,2,scope.$index)" class="ydinput">
								<el-input v-model="scope.row.order_delivery[0].delivery_num" placeholder="运单号"
									size="small" :disabled="!scope.row.order_delivery[0].kbj"></el-input>
								<span class="a" @click="ondtydh(scope.$index)"
									v-if="scope.row.order_delivery[0].kbj">运单号提交</span>
								<span @click="ondtydh(scope.$index)"
									v-if="!scope.row.order_delivery[0].kbj">运单号已提交</span>
							</div>
							<div
								v-if="isPddDeliverySyncFailed(scope.row)"
								class="pdd-delivery-sync-error"
							>{{ formatPddDeliverySyncTip(scope.row) }}</div>
						</template>
					</el-table-column>
					<el-table-column label="快递状态" align="center" header-align="center" min-width="80px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_delivery" :key="k">
								<el-popover width="470" trigger="click" @show="ongdd(v.id)" @hide="kdlist = []">
									<div class="kdbox">
										<el-table :data="kdlist" style="width: 100%">
											<el-table-column width="160" prop="time_str" label="时间"></el-table-column>
											<el-table-column width="300" prop="desc" label="地点和跟踪进度"></el-table-column>
										</el-table>
									</div>
									<span slot="reference" :class="oncp(v.delivery_status)">{{v.delivery_status_str}}</span>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="out_trade_no" label="客户单号" align="center" header-align="center"
						min-width="140px">
						<template slot-scope="scope">
							<div>{{scope.row.cfrom_str}}</div>
							<div @click="oncopy(scope.row.out_trade_no)">{{scope.row.out_trade_no}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="seller_remark" label="备注/备忘/代理备忘" align="center" header-align="center"
						min-width="150px">
						<template slot-scope="scope">
							<i class="hq el-icon-s-flag" v-if="scope.row.seller_mark"
								:style="'color:'+onmark(scope.row.seller_mark)"></i>
							<!-- 备注 -->
							<p>{{scope.row.buyer_remark}}</p>
							<!-- 备忘 -->
							<p :style="'color:'+onmark(scope.row.seller_mark)">{{scope.row.seller_memo}}</p>
							<!-- 渠道备忘 -->
							<p v-if="scope.row.buyer_memo_show_seller == 1">{{scope.row.buyer_memo}}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="130px">
						<template slot-scope="scope">
							<div class="operation_i">
								<!-- 通用 -->
								<div>
									<span @click="oninfo(scope.row)">详细</span>
									<span @click="onmemo(scope.row)">备忘</span>
								</div>
								<div>
									<el-dropdown @command="handleCommand($event,scope.row)" placement="bottom">
										<span>标记</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item :command="0">取消</el-dropdown-item>
											<el-dropdown-item :command="v.id" v-for="(v,k) in appdata.list.mark"
												:key="k"><i :style="'color:'+v.color">{{v.name}}</i></el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
								<!-- 已付款 -->
								<div v-if="scope.row.order_status == 1">
									<span @click="onpeihuo(scope.row.trade_no)">配货</span>
									<span @click="onwork(scope.row)">工单</span>
								</div>
								<!-- 配货中 -->
								<div v-if="scope.row.order_status == 3">
									<span @click="onsend(scope.row.trade_no)">发货</span>
									<span @click="onwuhuo(scope.row.trade_no)">无货</span>
								</div>
								<div v-if="scope.row.order_status == 3 && scope.row.apply_cancel == 1">
									<span @click="onaco(scope.row.trade_no)">确认取消</span>
								</div>
								<div
									v-if="scope.row.order_status == 3 && scope.row.delivery_is_repeat == 1 && scope.row.delivery_ignore_repeat == 0">
									<span @click="onsdir(scope.row.trade_no)">忽略重复快递号</span>
								</div>
								<div v-if="scope.row.order_status == 3">
									<span @click="onwork(scope.row)">工单</span>
								</div>

								<!-- 已发货 -->
								<div v-if="scope.row.order_status == 4">
									<span @click="onstopOrder(scope.row.trade_no,scope.row.shop_id)">作废</span>
									<span @click="onwork(scope.row)">工单</span>
								</div>
								<!-- 售后处理 service 不为空 -->
								<div v-if="scope.row.order_status == 4 && scope.row.service">
									<span @click="onservicedetails(scope.row)">售后处理</span>
								</div>
								<div v-if="scope.row.order_status == 4">
									<span @click="ongdh(scope.row)">改单号</span>
								</div>

								<!-- 退货中	已退货 已拒退 已成交-->
								<div
									v-if="(scope.row.order_status == 5 || scope.row.order_status == 6 || scope.row.order_status == 8 || scope.row.order_status == 10) && scope.row.service">
									<span @click="onservicedetails(scope.row)">售后处理</span>
								</div>
								<!-- 已作废 -->
								<div
									v-if="scope.row.order_status == 5 || scope.row.order_status == 6 || scope.row.order_status == 7 || scope.row.order_status == 8 || scope.row.order_status == 10">
									<span @click="onwork(scope.row)">工单</span>
								</div>

								<div>
									<i v-if="scope.row.buchang!='0.00'">(代理已补偿￥{{scope.row.buchang}})</i>
								</div>
							</div>
							<div class="simg">
								<el-tooltip :content="scope.row.buyer_user_qq" placement="bottom" effect="light">
									<img src="../../assets/image/qq.png" @click="oncopy(scope.row.buyer_user_qq)">
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="订单详情" :visible.sync="detailsVisible" width="80%" :before-close="onclose">
			<orderdetails :checkobj="checkedobj" v-if="detailsVisible" @odload="onbolist()"></orderdetails>
		</el-dialog>

		<el-dialog title="订单备忘" :visible.sync="memoVisible" width="60%" :before-close="onclose2">
			<memo ref="memo" :checkobj="checkedobj" v-if="memoVisible" @ondata="onmemodata"></memo>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onsubmemo()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单工单申请" :visible.sync="workVisible" width="70%" :before-close="onclose3">
			<workdialog :checkobj="checkedobj" v-if="workVisible" ref="workdialog" @subwork="subwork"></workdialog>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose3">取消</el-button>
				<el-button type="primary" @click="onsubwork()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单售后详情" :visible.sync="sdVisible" width="80%" :before-close="onclose5">
			<servicedetails :checkobj="checkedobj" v-if="sdVisible" @odload="onbolist()"></servicedetails>
		</el-dialog>

		<el-dialog title="修改快递单号" :visible.sync="gdhVisible" width="80%" :before-close="onclose6">
			<gaidanhao :checkobj="checkedobj" ref="gdh" v-if="gdhVisible" @sub="subgdh"></gaidanhao>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose6">取消</el-button>
				<el-button type="primary" @click="onsubgdh()">新单号提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="批量快递导入" :visible.sync="uploadVisible" width="600px" :before-close="onclose7">
			<div class="uploaddiv">
				<div class="i_b">
					<el-input v-model="uploadtext" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onreturnUrl" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload">下载模版</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose7">取消</el-button>
				<el-button type="primary" @click="onfile()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Order',
		data() {
			return {
				//列表查询
				list: [],
				tablist: [{
					name: 'qb',
					label: '全部',
					num: 0
				},{
					name: 'yfk',
					label: '已付款',
					num: 0
				},{
					name: 'phz',
					label: '配货中',
					num: 0
				},{
					name: 'yfh',
					label: '已发货',
					num: 0
				},{
					name: 'yqx',
					label: '已取消',
					num: 0
				}],
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,
				qudao: [],
				kdlist: [],
				formfilter: {
					shop_id: "",
					trade_no: "",
					recv_name: "",
					delivery_num: "",
					apply_cancel: "",
					order_status: "",
					out_trade_no: "",
					recv_mobbile: "",
					style_number: "",
					cfrom: "",
					seller_mark: "",
					date_type: "",
					mydate: [],
					btime: "",
					etime: "",
					delivery_id: "",
					seller_memo: "",
					brand: "",
					weifa: 0,
				},
				rules: {
					money: [{
						required: true,
						message: '金额不能为空',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '必须为数字值',
						trigger: 'blur'
					}]
				},

				//选中的对象
				checkedobj: {},

				//详情
				detailsVisible: false,

				//订单备忘
				memoVisible: false,

				//工单
				workVisible: false,

				//售后详情
				sdVisible: false,

				//快递单
				gdhVisible: false,

				//批量快递导入
				uploaddata: {
					file_name: "",
					path: ""
				},
				uploadVisible: false,
				
				alldata: [],
				
				btnshow: 0,
				
				activeName: "qb",
				
				uploadtext: ""
			}
		},

		inject: ['appdata', 'oncopy', 'formatDate'],

		mounted() {
			// this.onbolist();
			this.onqudao();
			// this.ontablist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		watch: {
			activeName: {
				handler(newVal, oldVal) {
					if(newVal == 'qb') {
						this.formfilter.order_status = "";
					}
					
					if(newVal == 'yfk') {
						this.formfilter.order_status = 1;
					}
					
					if(newVal == 'phz') {
						this.formfilter.order_status = 3;
					}
					
					if(newVal == 'yfh') {
						this.formfilter.order_status = 4;
					}
					
					if(newVal == 'yqx') {
						this.formfilter.order_status = 2;
					}
					this.formfilter.weifa = 0;
					this.onfilter();
				},
				// immediate: true
			},
			
			'$route.query': {
				handler(newQuery, oldQuery) {
					if (Object.keys(this.$route.query).length > 0) {
						for (let key in this.$route.query) {
							if (key == 'order_status') {
								this.formfilter[key] = Number(this.$route.query[key]);
							} else {
								this.formfilter[key] = this.$route.query[key];
							}
						}
					} else {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						this.formfilter.date_type = 1;
						this.formfilter.mydate = [this.formatDate(start), this.formatDate(end)];
					}
					if(this.$route.params.weifa == 1) {
						this.formfilter.weifa = 1;
					}
					this.onbolist();
					this.ontablist();
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},
		
		methods: {
			getPddDeliverySyncData(row) {
				if (!row) {
					return {}
				}
				if (row.delivery_sync_status != null && row.delivery_sync_status !== '') {
					return row
				}
				return row.pdd_data || {}
			},

			isPddDeliverySyncFailed(row) {
				var data = this.getPddDeliverySyncData(row)
				var status = data.delivery_sync_status
				if (status === 'failed' || status == 2) {
					return true
				}
				var text = data.delivery_sync_status_str != null ? String(data.delivery_sync_status_str) : ''
				return !!(text && text.indexOf('失败') !== -1)
			},

			formatPddDeliverySyncTip(row) {
				var data = this.getPddDeliverySyncData(row)
				var error = data.delivery_sync_error ? String(data.delivery_sync_error) : '同步失败'
				return '同步失败：' + error + '，请尝试前往商家后台发货'
			},

			getOrderDateTimeParts(value) {
				if (value == null || value === '') {
					return { date: '-', time: '' }
				}
				var s = String(value).trim()
				var matched = s.match(/^(\d{4}[-/]\d{1,2}[-/]\d{1,2})\s+(\d{1,2}:\d{2}(?::\d{2})?)/)
				if (matched) {
					return { date: matched[1], time: matched[2] }
				}
				if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(s)) {
					return { date: s, time: '' }
				}
				return { date: s, time: '' }
			},

			formatOrderDate(value) {
				return this.getOrderDateTimeParts(value).date
			},

			formatOrderTime(value) {
				return this.getOrderDateTimeParts(value).time
			},

			// 基础查询
			handleCurrentChange() {
				this.onbolist();
				this.ontablist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onbolist();
				this.ontablist();
			},

			onfilter() {
				this.page = 1;
				this.onbolist();
				this.ontablist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					trade_no: "",
					recv_name: "",
					delivery_num: "",
					apply_cancel: "",
					out_trade_no: "",
					recv_mobbile: "",
					style_number: "",
					cfrom: "",
					seller_mark: "",
					date_type: "",
					mydate: [],
					btime: "",
					etime: "",
					delivery_id: "",
					seller_memo: "",
					brand: "",
					order_status: this.formfilter.order_status,
					weifa: 0
				};
				if(this.activeName == 'qb') {
					this.formfilter.order_status = "";
				};
				this.page = 1;
				this.onbolist();
				this.ontablist();
			},
			
			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				this.$axios.post('api/user/seller_order_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			ontablist() {
				this.$axios.get('api/user/seller_order_num').then(res => {
					if (res.data.code == 0) {
						this.tablist[1].num = res.data.data.paid_num;
						this.tablist[2].num = res.data.data.peihuo_num;
						this.tablist[3].num = res.data.data.fahuo_num;
						this.tablist[4].num = res.data.data.cancel_num;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onbolist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/seller_order_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.btnshow = 0;
						if(obj.order_status == 1) {
							this.btnshow = 1;
						}
						if(obj.order_status == 3) {
							this.btnshow = 2;
						}
						
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			// 详情
			oninfo(obj) {
				this.checkedobj = obj;
				this.detailsVisible = true;
			},

			onclose() {
				this.checkedobj = {};
				this.detailsVisible = false;
			},

			//备忘
			onmemo(obj) {
				this.checkedobj = obj;
				this.memoVisible = true;
			},

			onclose2() {
				this.checkedobj = {};
				this.memoVisible = false;
			},

			onsubmemo() {
				this.$refs.memo.ondata();
			},

			onmemodata(data) {
				this.$axios.post('api/user/seller_memo', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose2();
						this.onbolist();
						this.ontablist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onmark(id, n) {
				var color = "#000";
				if (this.appdata.list.mark) {
					this.appdata.list.mark.forEach((v, k) => {
						if (v.id == id) {
							color = v.color
						}
					})
				}

				return color;
			},

			handleCommand(val, data) {
				var obj = {
					trade_no: data.trade_no,
					seller_mark: val,
					seller_memo: data.seller_memo,
					seller_memo_show_buyer: data.seller_memo_show_buyer
				};
				this.onmemodata(obj);
			},

			//已付款-配货
			onpeihuo(trade_no) {
				this.$confirm('是否开始给该条订单配货, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/peihuo', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('设置成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中 发货
			onsend(trade_no) {
				this.$confirm('是否给该条订单发货, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/send', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中 无货
			onwuhuo(trade_no) {
				this.$confirm('是否确定该条订单无货, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/wuhuo_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中 确认取消
			onaco(trade_no) {
				this.$confirm('是否取消该条订单的申请, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/agree_cancel_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中 忽略快递单号
			onsdir(trade_no) {
				this.$confirm('是否忽略重复的快递单号, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/set_delivery_ignore_repeat', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中 运单号提交
			ondtydh(index) {
				if (!this.list[index].order_delivery[0].delivery_id) {
					this.$message.warning("请选择快递");
					return;
				}

				if (!this.list[index].order_delivery[0].delivery_num) {
					this.$message.warning("请填写快递单号");
					return;
				}

				var obj = {
					trade_no: this.list[index].trade_no,
					delivery_id: this.list[index].order_delivery[0].delivery_id,
					delivery_num: this.list[index].order_delivery[0].delivery_num,
					detail: ""
				}

				this.$axios.post('api/user/set_multi_delivery', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('修改成功');
						var row = this.list[index]
						if (row && row.order_delivery && row.order_delivery[0]) {
							this.$set(row.order_delivery[0], 'kbj', false)
						}
						this.ontablist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			//判断快递在表格中的状态
			inputshow(obj, n, i) {
				if (obj.order_status == 3) {
					if (n == 2) {
						if (obj.order_delivery.length == 0 || obj.order_delivery.length == 1) {
							if (obj.order_delivery.length == 0) {
								this.list[i].order_delivery.push({
									delivery_id: obj.delivery_id,
									delivery_num: "",
									kbj: true
								});
							}
							return true;
						} else {
							return false;
						}

					} else {
						if (obj.order_delivery.length > 1) {
							return true;
						} else {
							return false;
						}
					}
				} else {
					if (n == 1) {
						return true;
					} else {
						return false;
					}
				}
			},

			//已发货-作废
			onstopOrder(trade_no, shop_id) {
				var obj = {};
				obj.shop_id = shop_id,
					this.$axios.post('api/user/stop_order_tips', obj).then(res => {
						if (res.data.code == 0) {
							this.onstopOrder1(trade_no, res.data.data.tips);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
			},

			onstopOrder1(trade_no, text) {
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/stop_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//工单
			onwork(obj) {
				this.checkedobj = obj;
				this.workVisible = true;
			},

			onclose3() {
				this.checkedobj = {};
				this.workVisible = false;
			},

			subwork(res) {
				this.onbolist();
				this.ontablist();
				this.onclose3();
			},

			onsubwork() {
				this.$refs.workdialog.onsub();
			},

			//售后详情
			onservicedetails(obj) {
				this.checkedobj = obj;
				this.sdVisible = true;
			},

			onclose5() {
				this.checkedobj = {};
				this.sdVisible = false;
			},

			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1 || columnIndex == 2) {
					if (row.order_status == 7) {
						return "o_row"
					}

					if (row.order_status == 11) {
						return "y_row"
					}

					var n = row.total_num ? row.total_num:0;
					var t = row.total_true_num ? row.total_true_num:0;
					if (n > t) {
						return "yellor_row"
					}
				}
			},

			ongdd(id) {
				var obj = {};
				obj.id = id;
				this.$axios.post('api/user/get_delivery_detail', obj).then(res => {
					if (res.data.code == 0) {
						this.kdlist = res.data.data.content.reverse();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			//改单号
			ongdh(obj) {
				this.checkedobj = obj;
				this.gdhVisible = true;
			},

			onclose6() {
				this.checkedobj = {};
				this.gdhVisible = false;
			},

			onsubgdh() {
				this.$refs.gdh.onsub();
			},

			subgdh(arr) {
				if (arr.length == 0) {
					this.$message.warning('您未修改任何订单号，请勿重复提交');
					return;
				}
				arr.forEach((v, k) => {
					this.$axios.post('api/user/gaidanhao', v).then(res => {
						if (res.data.code == 0) {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose6();
								this.onbolist();
								this.ontablist();
							}
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},

			//批量快递导入
			onidelivery() {
				this.uploadVisible = true;
			},

			onreturnUrl(url, res, file) {
				//原文件名称
				this.uploaddata.file_name = file.name;
				this.uploaddata.path = res.file;
				this.uploadtext = this.uploaddata.file_name;
			},

			onclose7() {
				this.uploadVisible = false;
				this.uploaddata = {
					file_name: "",
					path: ""
				};
				this.uploadtext = "";
			},

			onfile() {
				if (!this.uploaddata.file_name || !this.uploaddata.path) {
					this.$message.error("请先上传模版");
					return;
				}
				var obj = {
					path: this.uploaddata.path
				};
				this.$axios.post('api/user/import_delivery', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('上传成功，请前往任务中心-导入列表查看状态');
						this.$parent.oncount();
						this.onclose7();
						// this.onbolist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ondownload() {
				var url ="https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E5%AF%BC%E5%85%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%A8%A1%E7%89%88.xlsx";
				window.open(url, '_blank');
			},
			
			handleSelectionChange(val) {
				this.alldata = val;
			},
			
			onpeihuoAll() {
				var arr = JSON.parse(JSON.stringify(this.alldata));
				var cg = 0;
				if(arr.length > 0) {
					arr.forEach((v,k)=>{
						var obj = {
							trade_no: v.trade_no
						}
						this.$axios.post('api/user/peihuo', obj).then(res => {
							if (res.data.code == 0) {
								cg++;
								
							} else {
								this.$message.error(res.data.message);
							}
							
							if(cg == arr.length) {
								this.$message.success('设置成功');
								this.onbolist();
								this.ontablist();
							}
							
						}).catch(err => {
							console.log(err)
						})
					})
				}else {
					this.$message.warning('必须选择一条数据');
				}
			},
			
			onsendAll() {
				var arr = JSON.parse(JSON.stringify(this.alldata));
				var cg = 0;
				if(arr.length > 0) {
					arr.forEach((v,k)=>{
						var obj = {
							trade_no: v.trade_no
						}
						this.$axios.post('api/user/send', obj).then(res => {
							if (res.data.code == 0) {
								cg++;
							} else {
								this.$message.error(res.data.message);
							}
							
							if(cg == arr.length) {
								this.$message.success('设置成功');
								this.onbolist();
								this.ontablist();
							}
						}).catch(err => {
							console.log(err)
						})
					})
				}else {
					this.$message.warning('必须选择一条数据');
				}
			},
			
			oncp(i) {
				if(i) {
					if(i == 1 || i == 2 || i == 3) {
						return 'cp ysy'
					}
					
					if(i == 4 || i == 5) {
						return 'cp ysb'
					}
				}else {
					return 'cp'
				}
			},
			
			ontimestr(str) {
				if(str == '准时') {
					return 'color:green';
				}else if(str == '延误'){
					return 'color:red';
				} else {
					return '';
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.order {
		height: calc(100% + 54px);
	}

	.filterty .el-select {
		width: 120px;
	}

	.filterty .el-input {
		width: 120px;
	}

	.filterty .el-date-editor {
		width: 250px;
	}

	.tablediv {
		width: 100%;
	}

	.tablediv-compact {
		/deep/ .el-table td,
		/deep/ .el-table th {
			padding: 2px 0;
		}

		/deep/ .el-table .cell {
			line-height: 16px;
			padding-left: 4px;
			padding-right: 4px;
		}

		/deep/ .el-table .cell > div {
			line-height: 16px;
		}

		/deep/ .el-table .cell > div + div {
			margin-top: 1px;
		}

		/deep/ .operation_i > div + div {
			margin-top: 1px;
		}
	}

	.ts {
		color: #ff4714;
	}

	.hq {
		font-size: 20px;
	}

	.simg {
		width: 100%;
		display: flex;
		justify-content: center;

		img {
			width: 25px;
			height: 25px;
		}
	}

	.ydinput {
		span {
			color: #606266;
			font-size: 14px;
		}

		.a {
			color: #ff4714;
			cursor: pointer;
		}

		>div {
			margin-bottom: 2px;
		}
	}

	.delivery-name-text {
		width: 11em;
		margin: 0 auto;
		line-height: 1.3;
		word-break: break-all;
		white-space: normal;
	}

	/deep/ td.delivery-name-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}

	/deep/ td.delivery-name-column .el-input__suffix {
		background: transparent !important;
	}

	/deep/ td.delivery-name-column .el-input__suffix-inner {
		background: transparent !important;
	}

	/deep/ td.delivery-name-column .el-input__inner {
		padding-right: 18px;
		padding-left: 4px;
	}

	.delivery-num-text {
		line-height: 1.3;
		word-break: break-all;
		white-space: normal;
	}

	/deep/ td.delivery-num-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}

	.red {
		color: red;
	}

	.pdd-delivery-sync-error {
		margin-top: 1px;
		color: #f56c6c;
		font-size: 12px;
		line-height: 1.25;
		text-align: left;
		word-break: break-all;
	}

	.datetime-stack {
		line-height: 16px;
	}

	.datetime-stack .datetime-time {
		color: #606266;
	}

	.kdbox {
		width: 470px;
		height: 400px;
		overflow: auto;
	}

	.cp {
		cursor: pointer;
		text-decoration: underline;
	}

	.tablebox {
		height: calc(100% - 158px);
	}
	
	.tabdiv {
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/order.vue